import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route } from "react-router-dom";
import LoginRoute from "./LoginRoute";

const LoginIndex = () => {
    console.log('LoginIndex Entry')
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>
                <Route path="/" element={<LoginRoute />} />
                <Route path="/:lng/*" element={<LoginRoute />} />
            </Routes>
        </Suspense>
    );
};

export default LoginIndex;
